// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "e18df59-dirty",
    "hash": "e18df59",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "e18df59-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
